import { useEffect } from 'react';
import { useRouteError } from 'react-router';

import ErrorTemplate from './error-template';

/**
 * `errorElement` корневого маршрута: ошибки, которые не поймал ErrorBoundary приложения
 * (он оборачивает только страницы), — в оверлее входа, LanguageGuard, провайдерах. Без него
 * роутер показывает свою техническую заглушку «Unexpected Application Error!» со стеком.
 * Переход на главную по кнопке снимает ошибку: роутер сбрасывает её при навигации.
 */
const RouteErrorFallback: React.FC = () => {
  const error = useRouteError();

  useEffect(() => {
    // Причину — в консоль для отладки; пользователю — понятный экран
    console.error('[router] uncaught route error', error);
  }, [error]);

  return <ErrorTemplate type="oops" />;
};

export default RouteErrorFallback;
